enum HouseholdType {
    Single = 'SINGLE',
    WithFamily = 'WITH_FAMILY',
    WithFriends = 'WITH_FRIENDS',
    WithPartner = 'WITH_PARTNER'
}

export default HouseholdType
